import { Controller } from "@hotwired/stimulus"
import { createTimeline } from "animejs"

// Connects to data-controller="pages--modals"
export default class extends Controller {
  static targets = [
    "modal",
    "backdrop",
    "container",
    "spinner",
    "content"
  ]

  contentTargetConnected(_) {
    this.spinnerTarget.classList.add("hidden")
  }

  show(_) {
    let timeline = createTimeline({
      defaults: {
        duration: 600,
        easing: "outCirc"
      },
      onBegin: () => {
        document.body.classList.add("overflow-hidden")
        this.modalTarget.classList.remove("hidden")
      }
    })

    timeline
      .add(this.containerTarget, {
        opacity: [0, 1]
      }, 0)

    // Nur wenn Bildschirmgröße < SM ist translateY Animation hinzufügen!
    if (document.body.dataset.screenSize != "") {
      timeline
        .add(this.backdropTarget, {
          opacity: [0, 1],
        }, 0)
        .add(this.containerTarget, {
          translateY: ["6%", "0%"]
        }, 0)
    }

    timeline.play()
  }

  hide(_) {
    document.body.classList.remove("overflow-hidden")
    this.modalTarget.classList.add("hidden")

    this.spinnerTarget.classList.remove("hidden")
    this.contentTarget.innerHTML = ""

    this.modalTarget.removeAttribute("style")
    this.contentTarget.removeAttribute("style")
    this.containerTarget.removeAttribute("style")
  }
}
